"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMARTLINK_BASE_URL = void 0;
exports.SMARTLINK_BASE_URL = {
    localhost: "http://localhost:5173/habit-smart-link/",
    int: "https://distributors.integrations.habit.io/habit-smart-link/",
    qa: "https://distributors.qa.habit.io/habit-smart-link/",
    default: "https://distributors.habit.io/habit-smart-link/",
};
